(() => {
  const marker = 'dominator-designer-notes-20260617';
  if (window[marker]) return;
  window[marker] = true;

  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const bindAnnouncementCarousel = () => {
    const bar = document.querySelector('[data-announcement-carousel]');
    if (!bar || bar.dataset.designerCarouselBound === 'true') return;
    const items = all('[data-announcement-item]', bar).filter((item) => item.textContent.trim());
    if (items.length <= 1) return;
    bar.dataset.designerCarouselBound = 'true';
    let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pause = bar.querySelector('[data-announcement-pause]');
    let paused = reducedMotion.matches;
    const syncPause = () => {
      if (!pause) return;
      pause.textContent = paused ? 'Play' : 'Pause';
      pause.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
    };
    pause?.addEventListener('click', () => { paused = !paused; syncPause(); });
    reducedMotion.addEventListener('change', event => { if (event.matches) { paused = true; syncPause(); } });
    syncPause();
    window.setInterval(() => {
      if (paused || document.hidden || bar.matches(':hover') || bar.contains(document.activeElement)) return;
      index = (index + 1) % items.length;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
    }, 3500);
  };

  const bindVariantScrollGuard = () => {
    all('[data-variant-pill], [data-option-select]').forEach((control) => {
      if (control.dataset.designerScrollGuardBound === 'true') return;
      control.dataset.designerScrollGuardBound = 'true';
      const preserve = () => {
        const x = window.scrollX;
        const y = window.scrollY;
        requestAnimationFrame(() => {
          if (Math.abs(window.scrollY - y) > 4) window.scrollTo(x, y);
        });
        window.setTimeout(() => {
          if (Math.abs(window.scrollY - y) > 4) window.scrollTo(x, y);
        }, 120);
      };
      control.addEventListener('click', preserve, true);
      control.addEventListener('change', preserve, true);
    });
  };

  const bindReviewShowAll = () => {
    all('[data-review-show-all]').forEach((button) => {
      if (button.dataset.designerReviewShowAllBound === 'true') return;
      button.dataset.designerReviewShowAllBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        all('[data-review-filter]').forEach((filter) => {
          const selected = (filter.dataset.reviewFilter || 'All') === 'All';
          filter.classList.toggle('selected', selected);
          filter.setAttribute('aria-pressed', String(selected));
        });
        all('[data-review-item]').forEach((item) => { item.hidden = false; });
        button.textContent = 'All reviews shown';
      }, true);
    });
  };

  const boot = () => {
    bindAnnouncementCarousel();
    bindVariantScrollGuard();
    bindReviewShowAll();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', boot);
})();


(() => {
  const marker = 'dominator-designer-final-controls-20260617';
  if (window[marker]) return;
  window[marker] = true;

  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const one = (selector, root = document) => root.querySelector(selector);

  const richSourceFor = (root, attr, value) => {
    if (!root || !value) return null;
    return all(`[${attr}]`, root).find((node) => node.getAttribute(attr) === value) || null;
  };

  const preserveScroll = (fn) => {
    const x = window.scrollX;
    const y = window.scrollY;
    const active = document.activeElement;
    fn();
    requestAnimationFrame(() => {
      if (active && typeof active.focus === 'function') active.focus({ preventScroll: true });
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(x, y);
    });
    window.setTimeout(() => {
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(x, y);
    }, 140);
  };

  const setText = (selector, value, root = document) => {
    const node = one(selector, root);
    if (node && value) node.textContent = value;
  };

  const setImage = (selector, src, alt, root = document) => {
    const image = one(selector, root);
    if (!image || !src) return;
    image.src = src;
    image.alt = alt || '';
  };

  const modeData = window.DominatorTheme?.homeModes || window.DominatorTheme?.modeData || null;

  const applyHomeMode = (category) => {
    const hero = one('[data-home-hero]');
    const data = modeData?.[category];
    if (!hero || !data) return;
    const previousHeight = Math.ceil(hero.getBoundingClientRect().height);
    if (previousHeight) hero.style.minHeight = previousHeight + 'px';
    Object.keys(modeData).forEach((mode) => hero.classList.toggle('hero--' + mode, mode === category));
    setText('[data-home-hero-title]', data.title, hero);
    setText('[data-home-hero-copy]', data.text, hero);
    setText('[data-hero-product-title]', data.productTitle, hero);
    setText('[data-hero-product-copy]', data.productCopy, hero);
    setImage('[data-home-hero-image]', data.heroImage, data.title, hero);
    setImage('[data-hero-product-image]', data.productImage, data.productTitle, hero);
    const primary = one('[data-home-hero-primary]', hero);
    if (primary) {
      primary.textContent = data.primaryLabel || primary.textContent;
      primary.href = data.primaryHref || primary.href;
    }
    const buy = one('[data-home-hero-buy]', hero);
    if (buy && data.buyHref) buy.href = data.buyHref;
    requestAnimationFrame(() => { hero.style.minHeight = ''; });
  };

  const reorderRunway = (category) => {
    const runway = one('[data-home-system-showcases]');
    if (!runway) return;
    const previousHeight = Math.ceil(runway.getBoundingClientRect().height);
    if (previousHeight) runway.style.minHeight = previousHeight + 'px';
    const groups = {
      hoops: ['hoops', 'hoop-picker'],
      pickleball: ['pickleball', 'net-picker'],
      lights: ['lights', 'light-picker']
    };
    const selected = groups[category] || groups.hoops;
    const ordered = [...selected, ...Object.entries(groups).filter(([key]) => key !== category).flatMap(([, ids]) => ids)];
    const heading = one(':scope > .section-heading', runway);
    let anchor = heading ? heading.nextSibling : runway.firstChild;
    ordered.map((id) => document.getElementById(id)).filter(Boolean).forEach((section) => {
      runway.insertBefore(section, anchor);
      anchor = section.nextSibling;
    });
    requestAnimationFrame(() => { runway.style.minHeight = ''; });
  };

  const bindHomeTabs = () => {
    const tabs = all('[data-category-tab]');
    let pauseHomeAutoRotation = () => {};
    const activateTab = (tab) => {
      if (!tab) return;
      const category = tab.dataset.categoryTab || 'hoops';
      preserveScroll(() => {
        tabs.forEach((candidate) => {
          const selected = candidate === tab;
          candidate.classList.toggle('is-active', selected);
          candidate.classList.toggle('selected', selected);
          candidate.setAttribute('aria-selected', String(selected));
        });
        applyHomeMode(category);
        reorderRunway(category);
      });
    };

    tabs.forEach((tab) => {
      if (tab.dataset.designerFinalTabBound === 'true') return;
      tab.dataset.designerFinalTabBound = 'true';
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        if (modeData) event.stopImmediatePropagation();
        pauseHomeAutoRotation();
        activateTab(tab);
      }, true);
    });

    const hero = one('[data-home-hero-auto]');
    if (!hero || hero.dataset.homeAutoRotateBound === 'true' || tabs.length <= 1 || !modeData) return;
    hero.dataset.homeAutoRotateBound = 'true';
    let autoPaused = false;
    let rotationTimer = null;
    const configuredStopOffset = Number(hero.dataset.homeHeroAutoplayStopOffset || 40) || 40;
    const scrollStopOffset = Math.min(configuredStopOffset, 40);
    const pauseAuto = () => {
      if (autoPaused) return;
      autoPaused = true;
      hero.dataset.homeHeroAutoPaused = 'true';
      if (rotationTimer) {
        window.clearInterval(rotationTimer);
        rotationTimer = null;
      }
    };
    const pauseIfScrolled = () => {
      if (window.scrollY > scrollStopOffset) pauseAuto();
    };
    pauseHomeAutoRotation = pauseAuto;
    window.addEventListener('scroll', pauseIfScrolled, { passive: true });
    window.addEventListener('wheel', pauseAuto, { passive: true, once: true });
    window.addEventListener('touchstart', pauseAuto, { passive: true, once: true });
    window.addEventListener('pointerdown', pauseAuto, { passive: true, once: true });
    window.addEventListener('keydown', pauseAuto, { once: true });
    pauseIfScrolled();
    let index = Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active') || tab.classList.contains('selected')));
    const interval = Number(hero.dataset.homeHeroAutoplayInterval || 10000) || 10000;
    rotationTimer = window.setInterval(() => {
      if (autoPaused || window.scrollY > scrollStopOffset) {
        pauseAuto();
        return;
      }
      index = (index + 1) % tabs.length;
      activateTab(tabs[index]);
    }, interval);
  };

  const bindCompareDetails = () => {
    all('[data-compare-expand]').forEach((button) => {
      if (button.dataset.designerFinalCompareBound === 'true') return;
      button.dataset.designerFinalCompareBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        preserveScroll(() => {
          const card = button.closest('.comparison-card') || button.closest('[data-product-compare-card]') || button.parentElement;
          const details = card ? one('[data-compare-details]', card) : null;
          if (!details) return;
          const nextHidden = !details.hidden;
          details.hidden = nextHidden;
          all('[data-compare-extra]', card).forEach((row) => { row.hidden = nextHidden; });
          button.textContent = nextHidden ? 'See all detailed specs' : 'Hide detailed specs';
          button.setAttribute('aria-expanded', String(!nextHidden));
        });
      }, true);
    });
  };

  const bindReviewFilters = () => {
    all('[data-review-filter]').forEach((button) => {
      if (button.dataset.designerFinalReviewFilterBound === 'true') return;
      button.dataset.designerFinalReviewFilterBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const filter = button.dataset.reviewFilter || 'All';
        preserveScroll(() => {
          all('[data-review-filter]').forEach((candidate) => {
            const selected = candidate === button;
            candidate.classList.toggle('selected', selected);
            candidate.setAttribute('aria-pressed', String(selected));
          });
          all('[data-review-item]').forEach((item) => {
            const tag = item.dataset.reviewTag || '';
            item.hidden = filter !== 'All' && tag !== filter;
          });
        });
      }, true);
    });
  };


  const bindProductFinder = () => {
    all('[data-product-finder]').forEach((finder) => {
      if (finder.dataset.designerFinderBound === 'true') return;
      finder.dataset.designerFinderBound = 'true';
      const matchTitle = one('[data-finder-match-title]', finder);
      const matchCopy = one('[data-finder-match-copy]', finder);
      const graphicLabel = one('[data-finder-graphic-label]', finder);
      const seeLink = one('[data-finder-see]', finder);
      const buyLink = one('[data-finder-buy]', finder);
      const answerTitle = one('[data-finder-answer-title]', finder);
      const answerCopy = one('[data-finder-answer-copy]', finder);

      all('[data-finder-tab]', finder).forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const label = tab.dataset.finderTab || '';
          preserveScroll(() => {
            all('[data-finder-tab]', finder).forEach((candidate) => {
              const selected = candidate === tab;
              candidate.classList.toggle('selected', selected);
              candidate.setAttribute('aria-selected', String(selected));
            });
            if (matchTitle) matchTitle.textContent = tab.dataset.matchTitle || '';
            if (matchCopy) matchCopy.textContent = tab.dataset.matchCopy || '';
            if (graphicLabel) graphicLabel.textContent = label;
            if (seeLink) {
              seeLink.href = tab.dataset.seeHref || '#product-compare';
              seeLink.textContent = 'See ' + label + ' picks';
            }
            if (buyLink) buyLink.href = tab.dataset.buyHref || '#product-compare';
          });
        }, true);
      });

      all('[data-finder-question]', finder).forEach((question) => {
        question.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => {
            all('[data-finder-question]', finder).forEach((candidate) => {
              const selected = candidate === question;
              candidate.classList.toggle('selected', selected);
              candidate.setAttribute('aria-pressed', String(selected));
            });
            if (answerTitle) answerTitle.textContent = question.dataset.finderQuestion || '';
            if (answerCopy) answerCopy.textContent = question.dataset.finderAnswer || '';
          });
        }, true);
      });
    });
  };

  const bindSpecDecisionPanel = () => {
    all('[data-spec-decision-panel]').forEach((panel) => {
      if (panel.dataset.designerSpecDecisionBound === 'true') return;
      panel.dataset.designerSpecDecisionBound = 'true';
      const label = one('[data-spec-decision-answer-label]', panel);
      const title = one('[data-spec-decision-answer-title]', panel);
      const copy = one('[data-spec-decision-answer-copy]', panel);
      const media = one('[data-spec-decision-answer-media]', panel);
      const answerRich = one('[data-spec-decision-answer-rich]', panel);
      const primaryLink = one('[data-spec-decision-primary-link]', panel);
      const secondaryLink = one('[data-spec-decision-secondary-link]', panel);
      const supportButton = one('[data-spec-decision-support-button]', panel);

      const setMedia = (src, mediaTitle) => {
        if (!src || !media) return;
        media.src = src;
        media.alt = mediaTitle || title?.textContent || '';
        all('[data-spec-media-thumb]', panel).forEach((thumb) => {
          const selected = thumb.dataset.specMediaSrc === src;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-pressed', String(selected));
        });
      };

      const setRichAnswer = (key, fallback) => {
        if (!answerRich) return;
        const source = richSourceFor(panel, 'data-spec-rich-source', key);
        if (source) {
          answerRich.innerHTML = source.innerHTML;
        } else if (fallback) {
          answerRich.innerHTML = `<p>${fallback}</p>`;
        }
      };

      const activate = (button) => {
        if (!button) return;
        all('[data-spec-decision-option]', panel).forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-selected', String(selected));
        });
        const data = button.dataset;
        if (label) label.textContent = data.specLabel || '';
        if (title) title.textContent = data.specTitle || '';
        if (copy) copy.textContent = data.specCopy || '';
        if (primaryLink) {
          primaryLink.textContent = (data.specPrimaryLabel || primaryLink.textContent).toUpperCase();
          if (data.specPrimaryUrl) primaryLink.href = data.specPrimaryUrl;
        }
        if (secondaryLink) {
          secondaryLink.textContent = (data.specSecondaryLabel || secondaryLink.textContent).toUpperCase();
          if (data.specSecondaryUrl) secondaryLink.href = data.specSecondaryUrl;
        }
        if (supportButton) {
          supportButton.textContent = (data.specSupportLabel || supportButton.textContent).toUpperCase();
          supportButton.dataset.supportIntent = data.specSupportIntent || supportButton.dataset.supportIntent || 'buying';
        }
        setMedia(data.specMedia || '', data.specTitle || '');
        setRichAnswer(data.specRich || '', data.specCopy || '');
      };

      const options = all('[data-spec-decision-option]', panel);
      options.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => activate(button));
        }, true);
      });

      all('[data-spec-media-thumb]', panel).forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => setMedia(button.dataset.specMediaSrc || '', button.textContent.trim()));
        }, true);
      });

      activate(options.find((button) => button.classList.contains('is-active')) || options[0]);
    });
  };

  const bindHomeResearchPanel = () => {
    all('[data-home-research-panel]').forEach((panel) => {
      if (panel.dataset.designerResearchBound === 'true') return;
      panel.dataset.designerResearchBound = 'true';
      const previewTitle = one('[data-research-preview-title]', panel);
      const previewCopy = one('[data-research-preview-copy]', panel);
      const previewLabel = one('[data-research-preview-label]', panel);
      const previewLink = one('[data-research-preview-link]', panel);
      const previewMediaWrap = one('[data-research-preview-media-wrap]', panel);
      const previewMedia = one('[data-research-preview-media]', panel);

      const activate = (item) => {
        if (!item) return;
        const summary = one('summary', item);
        const detail = one('small', item);
        if (!summary || !detail) return;
        all('[data-research-item]', panel).forEach((candidate) => {
          const selected = candidate === item;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-current', selected ? 'true' : 'false');
          if ('open' in candidate) candidate.open = selected;
        });
        if (previewTitle) previewTitle.textContent = summary.textContent.trim();
        if (previewCopy) previewCopy.textContent = item.dataset.researchAnswer || detail.textContent.trim();
        if (previewLabel) previewLabel.textContent = item.dataset.researchLabel || 'Research answer';
        if (previewLink) {
          const linkHref = item.dataset.researchLink || '';
          const linkLabel = item.dataset.researchLinkLabel || '';
          if (linkHref && linkLabel) {
            previewLink.hidden = false;
            previewLink.href = linkHref;
            previewLink.textContent = linkLabel;
          } else {
            previewLink.hidden = true;
            previewLink.removeAttribute('href');
          }
        }
        if (previewMedia && previewMediaWrap) {
          const mediaSrc = item.dataset.researchMedia || panel.dataset.researchDefaultMedia || '';
          if (mediaSrc) {
            previewMediaWrap.hidden = false;
            if (previewMedia.getAttribute('src') !== mediaSrc) previewMedia.src = mediaSrc;
            previewMedia.alt = item.dataset.researchMediaAlt || panel.dataset.researchDefaultMediaAlt || summary.textContent.trim();
          } else {
            previewMediaWrap.hidden = true;
            previewMedia.removeAttribute('src');
            previewMedia.alt = '';
          }
        }
      };

      const items = all('[data-research-item]', panel);
      items.forEach((item) => {
        const summary = one('summary', item);
        if (summary) summary.setAttribute('role', 'button');
        item.addEventListener('click', (event) => {
          const interactive = event.target.closest('a, button, input, textarea, select');
          if (interactive && !interactive.closest('summary')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => activate(item));
        }, true);
      });

      activate(items.find((item) => item.open) || items[0]);
    });
  };

  const bindCartQuantitySteppers = () => {
    all('[data-cart-quantity-row]').forEach((row) => {
      if (row.dataset.designerCartQtyBound === 'true') return;
      row.dataset.designerCartQtyBound = 'true';
      const input = one('[data-cart-quantity-input]', row);
      if (!input) return;
      const min = Number(input.min || 0);
      const normalize = (value) => {
        const next = Number.parseInt(String(value), 10);
        return Number.isFinite(next) ? Math.max(min, next) : Math.max(min, 0);
      };
      const setQuantity = (value) => {
        input.value = String(normalize(value));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      one('[data-cart-quantity-decrease]', row)?.addEventListener('click', (event) => {
        event.preventDefault();
        setQuantity(normalize(input.value) - 1);
      });
      one('[data-cart-quantity-increase]', row)?.addEventListener('click', (event) => {
        event.preventDefault();
        setQuantity(normalize(input.value) + 1);
      });
      input.addEventListener('blur', () => setQuantity(input.value));
    });
  };

  const bindShowAllReviews = () => {
    all('[data-review-show-all]').forEach((button) => {
      if (button.dataset.designerFinalShowAllBound === 'true') return;
      button.dataset.designerFinalShowAllBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        preserveScroll(() => {
          all('[data-review-item]').forEach((item) => { item.hidden = false; });
          all('[data-review-filter]').forEach((filter) => {
            const selected = (filter.dataset.reviewFilter || 'All') === 'All';
            filter.classList.toggle('selected', selected);
            filter.setAttribute('aria-pressed', String(selected));
          });
          button.textContent = 'All reviews shown';
        });
      }, true);
    });
  };

  const bindProductGallery = () => {
    const prepareModelViewer = (model, modelId = '') => {
      if (!model) return;
      model.dataset.productArViewer = 'true';
      if (modelId) model.dataset.mediaModelId = modelId;
      model.setAttribute('ar', '');
      model.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      model.setAttribute('ar-scale', 'fixed');
      model.setAttribute('ar-placement', 'floor');
      model.setAttribute('touch-action', 'pan-y');
      if (!one('[slot="ar-button"]', model)) {
        const arButton = document.createElement('button');
        arButton.type = 'button';
        arButton.slot = 'ar-button';
        arButton.className = 'pdp-model-ar-button';
        arButton.textContent = 'See it in your yard';
        model.append(arButton);
      }
      if (model.dataset.productArStatusBound !== 'true') {
        model.dataset.productArStatusBound = 'true';
        model.addEventListener('ar-status', (event) => {
          if (event.detail?.status !== 'failed') return;
          const section = one('[data-product-surface="inspection_tools"]');
          const status = one('[data-product-experience-status]', section || document);
          if (!status) return;
          status.textContent = 'AR could not start on this device. Use the 3D viewer or try a current Safari or Chrome browser.';
          status.hidden = false;
        });
      }
      if (typeof model.dismissPoster === 'function') {
        model.dismissPoster();
        return model;
      }
      customElements.whenDefined('model-viewer').then(() => model.dismissPoster?.());
      return model;
    };

    all('[data-product-media-gallery]').forEach((gallery) => {
      if (gallery.dataset.designerGalleryBound === 'true') return;
      gallery.dataset.designerGalleryBound = 'true';
      const main = one('[data-product-media-main]', gallery);
      const caption = one('[data-media-caption]', gallery);
      const arStage = one('[data-product-ar-stage]', gallery);
      const stagedModelId = arStage?.dataset.mediaModelId || '';
      prepareModelViewer(one('model-viewer', arStage), stagedModelId);
      const removeOrPark = (child) => {
        if (child.matches('model-viewer') && child.dataset.productArViewer === 'true' && child.dataset.mediaModelId === stagedModelId && arStage) {
          arStage.append(child);
          return;
        }
        child.remove();
      };
      const setMedia = (button) => {
        if (!main || !button?.dataset.mediaSrc) return;
        const existing = Array.from(main.children).filter((child) => child.matches('img, video, model-viewer'));
        const kind = button.dataset.mediaKind || 'image';
        const modelId = button.dataset.mediaModelId || '';
        const activeModel = one(':scope > model-viewer', main);
        if (kind === 'model' && activeModel?.dataset.mediaModelId === modelId) {
          prepareModelViewer(activeModel, modelId);
        } else {
          existing.forEach(removeOrPark);
        }
        if (kind === 'video') {
          const video = document.createElement('video');
          video.src = button.dataset.mediaSrc;
          video.controls = true;
          video.playsInline = true;
          main.prepend(video);
        } else if (kind === 'model') {
          if (!one(':scope > model-viewer', main)) {
            const stagedViewer = modelId === stagedModelId ? one('model-viewer', arStage) : null;
            if (stagedViewer) {
              main.prepend(stagedViewer);
            } else {
              const template = one(`[data-media-model-template="${modelId}"]`, gallery);
              if (!template) return;
              main.prepend(template.content.cloneNode(true));
            }
          }
          prepareModelViewer(one(':scope > model-viewer', main), modelId);
        } else {
          const image = document.createElement('img');
          image.src = button.dataset.mediaSrc;
          image.loading = 'eager';
          image.alt = button.dataset.mediaTitle || button.dataset.mediaLabel || '';
          main.prepend(image);
        }
        all('[data-media-src]', gallery).forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
        const label = one('[data-media-caption-label]', caption || gallery);
        const title = one('[data-media-caption-title]', caption || gallery);
        if (label) label.textContent = button.dataset.mediaLabel || '';
        if (title) title.textContent = button.dataset.mediaTitle || '';
      };
      all('[data-media-src]', gallery).forEach((button) => {
        button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
      });
      gallery.addEventListener('click', (event) => {
        const button = event.target.closest('[data-media-src]');
        if (!button || !gallery.contains(button)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        preserveScroll(() => setMedia(button));
      }, true);
    });
  };

  const openProductModelDialog = (gallery, viewer) => {
    const dialog = gallery.productModelDialog || one('[data-product-model-dialog]', gallery) || one('[data-product-model-dialog]');
    const stage = one('[data-product-model-dialog-stage]', dialog);
    if (!dialog || !stage || typeof dialog.showModal !== 'function') return false;
    gallery.productModelDialog = dialog;
    if (dialog.parentElement !== document.body) document.body.append(dialog);
    const scrollLeft = window.scrollX;
    const scrollTop = window.scrollY;
    const restoreScroll = () => window.scrollTo({ left: scrollLeft, top: scrollTop, behavior: 'instant' });

    const clearDialogViewer = () => stage.replaceChildren();

    if (dialog.dataset.productModelDialogBound !== 'true') {
      dialog.dataset.productModelDialogBound = 'true';
      one('[data-product-model-dialog-close]', dialog)?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', clearDialogViewer);
    }

    const dialogViewer = viewer.cloneNode(true);
    dialogViewer.setAttribute('loading', 'eager');
    stage.replaceChildren(dialogViewer);
    if (!dialog.open) dialog.showModal();
    restoreScroll();
    dialogViewer.dismissPoster?.();
    window.requestAnimationFrame(() => {
      dialogViewer.focus?.({ preventScroll: true });
      restoreScroll();
    });
    return true;
  };

  const bindProductExperienceActions = () => {
    all('[data-product-experience-action]').forEach((button) => {
      if (button.dataset.productExperienceBound === 'true') return;
      button.dataset.productExperienceBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const action = button.dataset.productExperienceAction;
        const section = button.closest('[data-product-surface="inspection_tools"]');
        const status = one('[data-product-experience-status]', section || document);
        const setStatus = (message) => {
          if (!status) return;
          status.textContent = message;
          status.hidden = !message;
        };

        if (action === 'ask') {
          window.DominatorTheme?.openSupport?.('buying', 'I have a question about this product.');
          return;
        }

        if (action === 'ar' && !window.matchMedia('(max-width: 720px)').matches) {
          setStatus('AR placement is available on a compatible phone. The desktop 3D viewer is available here.');
          return;
        }

        const gallery = one('[data-product-media-gallery]');
        const modelButton = one('[data-media-kind="model"]', gallery || document);
        if (!gallery || !modelButton) {
          setStatus('An interactive model is not available for this product yet. Ask Dominator for dimensions or placement help.');
          return;
        }

        const activeViewer = one('[data-product-media-main] > model-viewer', gallery);
        const stagedViewer = one('[data-product-ar-stage] model-viewer', gallery);
        const arViewer = activeViewer || stagedViewer;
        if (action === 'ar' && arViewer?.canActivateAR && typeof arViewer.activateAR === 'function') {
          setStatus('Opening full-scale AR placement.');
          const activation = arViewer.activateAR();
          activation?.catch?.(() => {
            setStatus('AR could not start on this device. Use the 3D viewer or try a current Safari or Chrome browser.');
          });
          return;
        }

        modelButton.click();
        const viewer = one('[data-product-media-main] > model-viewer', gallery);
        if (!viewer) {
          setStatus('The interactive model could not be opened. Refresh the page or ask Dominator for help.');
          return;
        }

        viewer.dismissPoster?.();
        if (action === '360') {
          setStatus('Drag to rotate. Pinch or scroll to zoom.');
          if (!window.matchMedia('(max-width: 720px)').matches && openProductModelDialog(gallery, viewer)) return;
          gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
          viewer.focus?.({ preventScroll: true });
          return;
        }

        gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setStatus('AR is not available in this browser. Use the 3D viewer here or reopen this page in current Safari on iPhone or Chrome on an ARCore-capable Android phone.');
      });
    });
  };

  const bindNetModeSwitcher = () => {
    all('[data-net-mode-switcher]').forEach((switcher) => {
      if (switcher.dataset.designerNetModeBound === 'true') return;
      switcher.dataset.designerNetModeBound = 'true';
      const root = switcher.closest('.product-pill-switcher') || switcher.parentElement;
      const setMode = (mode) => {
        all('[data-net-mode-control]', switcher).forEach((button) => {
          const selected = button.dataset.netModeControl === mode;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        all('[data-net-mode-product]', root || document).forEach((item) => {
          item.hidden = item.dataset.netModeProduct !== mode;
        });
      };
      all('[data-net-mode-control]', switcher).forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => setMode(button.dataset.netModeControl || 'portable'));
        }, true);
      });
      const active = one('[data-net-mode-control].is-active', switcher) || one('[data-net-mode-control]', switcher);
      setMode(active?.dataset.netModeControl || 'portable');
    });
  };

  const bindProductQuestionPanel = () => {
    all('[data-product-question-bank]').forEach((bank) => {
      if (bank.dataset.designerQuestionPanelBound === 'true') return;
      bank.dataset.designerQuestionPanelBound = 'true';
      const label = one('[data-product-question-answer-label]', bank);
      const title = one('[data-product-question-answer-title]', bank);
      const copy = one('[data-product-question-answer-copy]', bank);
      const answerRich = one('[data-product-question-answer-rich]', bank);
      const input = one('[data-product-question-input]', bank);
      const submit = one('[data-product-question-submit]', bank);
      const empty = one('[data-empty-question]', bank);
      const followup = one('[data-question-followup]', bank);

      const activate = (button) => {
        if (!button || button.hidden) return;
        all('[data-product-question-suggestion]', bank).forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
        if (label) label.textContent = button.dataset.questionLabel || 'Answer';
        if (title) title.textContent = button.dataset.questionTitle || button.textContent.trim();
        if (copy) copy.textContent = button.dataset.questionAnswer || '';
        if (answerRich) {
          const source = richSourceFor(bank, 'data-question-rich-source', button.dataset.questionRich || '');
          answerRich.innerHTML = source ? source.innerHTML : `<p>${button.dataset.questionAnswer || ''}</p>`;
          all('p', answerRich).forEach((paragraph) => {
            paragraph.innerHTML = paragraph.innerHTML.replace(/(^|<br\s*\/?>)\s*([•-]\s*)([^:<]+:)/gi, '$1$2<strong>$3</strong>');
          });
        }
        if (followup) followup.hidden = true;
      };

      const suggestions = all('[data-product-question-suggestion]', bank);
      const filterQuestions = () => {
        const query = (input?.value || '').trim().toLowerCase();
        const tokens = query.split(/\s+/).filter((token) => token.length > 1);
        let firstVisible = null;
        let visibleCount = 0;
        suggestions.forEach((button) => {
          const haystack = [
            button.dataset.questionLabel,
            button.dataset.questionTitle,
            button.dataset.questionAnswer,
            button.dataset.questionTags,
            button.dataset.questionText,
            button.textContent
          ].join(' ').toLowerCase();
          const visible = !tokens.length || tokens.every((token) => haystack.includes(token));
          button.hidden = !visible;
          if (visible) {
            visibleCount += 1;
            if (!firstVisible) firstVisible = button;
          }
        });
        if (empty) empty.hidden = visibleCount > 0;
        if (submit) submit.textContent = visibleCount > 0 ? 'Submit new question' : 'Submit this question';
        const active = suggestions.find((button) => button.classList.contains('is-active') && !button.hidden);
        if (active) activate(active);
        else if (firstVisible) activate(firstVisible);
      };

      suggestions.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => activate(button));
        }, true);
      });
      input?.addEventListener('input', () => preserveScroll(filterQuestions));
      filterQuestions();
    });
  };

  const boot = () => {
    bindHomeTabs();
    bindCompareDetails();
    bindReviewFilters();
    bindShowAllReviews();
    bindProductFinder();
    bindHomeResearchPanel();
    bindSpecDecisionPanel();
    bindProductGallery();
    bindProductExperienceActions();
    bindNetModeSwitcher();
    bindProductQuestionPanel();
    bindCartQuantitySteppers();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', boot);
})();

(() => {
  const marker = 'dominator-installer-state-map-20260618';
  if (window[marker]) return;
  window[marker] = true;

  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const one = (selector, root = document) => root.querySelector(selector);

  const bind = () => {
    all('[data-state-installer-map]').forEach((panel) => {
      if (panel.dataset.stateMapBound === 'true') return;
      panel.dataset.stateMapBound = 'true';
      const title = one('[data-state-installer-detail-title]', panel);
      const copy = one('[data-state-installer-detail-copy]', panel);
      const meta = one('[data-state-installer-detail-meta]', panel);
      const mode = one('[data-state-map-mode]', panel);
      const pins = all('[data-state-installer-region]', panel);
      const activate = (pin) => {
        if (!pin) return;
        pins.forEach((candidate) => {
          const selected = candidate === pin;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
        if (title) title.textContent = pin.dataset.stateDetailTitle || '';
        if (copy) copy.textContent = pin.dataset.stateDetailCopy || '';
        if (meta) meta.textContent = pin.dataset.stateDetailMeta || '';
        if (mode) mode.textContent = 'Showing ' + (pin.dataset.stateInstallerRegion || 'statewide') + ' installer coverage';
      };
      pins.forEach((pin) => {
        pin.setAttribute('aria-pressed', pin.classList.contains('is-selected') ? 'true' : 'false');
        pin.addEventListener('click', (event) => {
          event.preventDefault();
          activate(pin);
        });
      });
      activate(pins.find((pin) => pin.classList.contains('is-selected')) || pins[0]);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  window.addEventListener('pageshow', bind);
})();
